'use client'; // Mark as client component since we use hooks and browser APIs
/* eslint-disable */
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import axiosInstance from "../utils/axios";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaArrowsAlt, FaBed, FaBath} from "react-icons/fa";

const PropertyModel = ({ property }) => {
  const [propertyImages, setPropertyImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!property?.id) return;

    const fetchImages = async () => {
      try {
        const response = await axiosInstance.get(`/api/images/${property.id}`);
        setPropertyImages(response.data.length > 0 ? response.data : [{ image_url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80" }]);
      } catch (error) {
        console.error("Error fetching property images:", error);
        setPropertyImages([{ image_url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80" }]); // Fallback image
      }
    };

    fetchImages();
  }, [property]);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % propertyImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? propertyImages.length - 1 : prevIndex - 1));
  };

  return (
    
       <div className="w-64">
       <div className="relative h-56 w-full bg-gray-200 rounded-md">
          {propertyImages?.length > 0 ? (
            <div className="w-64">
              <img
                alt="Property"
                src={propertyImages[currentIndex]?.image_url || "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80"}
                className="w-full object-cover rounded mb-2"
                width={256}
                height={128}
                unoptimized
                loading="lazy"
              />
              
              {/* Image Navigation Buttons */}
              <div className="absolute top-1/2 left-0 right-0 flex justify-between px-2">
                <button
                  onClick={prevImage}
                  className="px-2 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-800"
                >
                  <Icon icon="ep:arrow-left-bold" width="16" height="16" />
                </button>
                <button
                  onClick={nextImage}
                  className="px-2 py-1 bg-gray-700 text-white rounded-lg hover:bg-gray-800"
                >
                  <Icon icon="weui:arrow-filled" width="16" height="16" />
                </button>
              </div>
            </div>
          ) : (
            <p className="text-center flex justify-center items-center"> 
              <ProgressSpinner />
            </p>
          )}
        </div>

                      <p className="text-red-600 font-bold mb-1">
                        {(property.status === "Rent" || property.listing_type === "Residential Rental") ? "Rent" : "Sale"}: ${property.price_or_rent}
                      </p>
                      <h3 className="font-semibold text-lg">
                        {property.home_type || property.listing_type || 'Property'}
                      </h3>
                      <div className="text-sm text-gray-600 mb-1">
                        {property.city}, {property.state}
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-700">
                        <FaBed /> {property.bedrooms || 0} Beds <FaBath /> {property.bathrooms || 0} Baths <FaArrowsAlt />{property.square_feet || property.total_square_footage || 0} sq ft
                      </div>
                      <button className="mt-2 bg-teal-500 text-white px-3 py-1 rounded text-sm">
                        View
                      </button>
                    </div>
      
    
  );
};

export default PropertyModel;
